import httpClient from 'angieslist-app-platform/lib/common/httpClient';
import queryString from 'query-string';

const businessListService = {
  getServiceProviders: (sortBy, limit, offset) => httpClient.get(`/gateway/office-home/v4/users/current/service_providers?${queryString.stringify({
    sortBy,
    limit,
    offset,
  })}`),
  getNewActivity: (adsServiceProviderIds, leadsServiceProviderIds) => httpClient.get(`/gateway/office-home/v1/service_providers/new_activity?${queryString.stringify({
    adsServiceProviderIds,
    leadsServiceProviderIds,
  })}`),
};

export default businessListService;



// WEBPACK FOOTER //
// ./src/app/common/businessList/businessListService.js